import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { ConfirmOptions } from "../../providers/ConfirmProvider";
import APButton from "../buttons/APButton";

const ConfirmDialog = ({
  open,
  options,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  options: ConfirmOptions;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  if (!options) return null;

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{options.title}</DialogTitle>

      <DialogContent>{options.description}</DialogContent>

      <DialogActions sx={{ justifyContent: "space-between", px: 2, pb: 2 }}>
        <APButton onClick={onCancel} text={options.cancelText ?? "Back"} />

        <APButton
          onClick={onConfirm}
          variant="contained"
          text={options.confirmText ?? "Yes"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
